import { styled } from '@mui/system';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import appTema from '../../servicos/mui/Theme.ts';
import { ExpandCircleDownOutlined } from '@mui/icons-material';

export const StyledAccordion = styled((props: AccordionProps) => (
	<MuiAccordion disableGutters defaultExpanded variant="outlined" {...props} />
 	)) (({ theme }) => ({
		border: `1px solid ${appTema.palette.divider}`,
		background: '#fff',
		borderRadius: '4px',
		'&:not(:last-child)': { borderBottom: 0, },
		'&:before': { display: 'none', },
 }));

export const StyledAccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ExpandCircleDownOutlined/>} {...props}/>
	 )) (({ theme }) => ({
		flexDirection: 'row-reverse',
		backgroundColor: appTema.palette.grey[100],
		'& .MuiAccordionSummary-content': {
			marginLeft: theme.spacing(1),
		},
 }));

 export const StyledAccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	paddingTop: theme.spacing(2),
	paddingRight: theme.spacing(2),
	paddingBottom: theme.spacing(2),
	paddingLeft: theme.spacing(2),
	borderTop: `1px solid ${appTema.palette.divider}`,
 }));
 